import { Skeleton } from "~/components/ui/skeleton";

export function DealCardSkeleton() {
  return (
    <div className="max-w-full">
      <div className="relative">
        {/* Product Image Skeleton */}
        <div className="relative aspect-square">
          <Skeleton className="h-full w-full rounded-[24px]" />
        </div>

        {/* Product Info Skeleton */}
        <div className="mt-2.5 space-y-2">
          {/* Product Name */}
          <Skeleton className="h-[20px] w-full" />

          {/* Price and Rating Row */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-[26px] w-[60px]" />
            <Skeleton className="h-[20px] w-[50px]" />
          </div>
        </div>
      </div>
    </div>
  );
}
